import { Injectable } from '@angular/core';
import { ListingExportConfig } from '@portal/shared/types/listing.types';
import { ExportRow } from '@portal/shared/types/export.types';
import { TableData } from '@portal/shared/types/api-response.types';
import { BaseStationItemListResponseDto } from '../base-stations-listing-page.types';
import { mapBaseStationToExport } from './base-stations-listing.export';

@Injectable()
export class BaseStationListingExportConfigService implements ListingExportConfig {
  readonly fileName = 'Export-Base_Station_Provisioning';

  readonly mapData = (data: TableData<BaseStationItemListResponseDto>): ExportRow[] =>
    data.data.map(mapBaseStationToExport);
}
